export default "__VITE_ASSET__BKGhoIZO__"